import React from 'react'
import developer from '../../../assets/developer.png'
import fb from '../../../assets/icons/fb.png'
import git from '../../../assets/icons/github.png'
import Linkedin from '../../../assets/icons/in.png'
import '../../../Styles/hero.css'
import Particle from '../../Shared/Particle'

const Hero = () => {
    return (
        <div className="max-w-7xl mx-auto px-10">
            <Particle />
            <div className="hero flex flex-col md:flex-row items-center justify-between gap-10 mt-8 md:mt-20 md:pb-8">
                <div data-aos="fade-right" data-aos-duration="2000">
                    <h2 class="text-4xl text-warning font-bold">Hello</h2>
                    <h2 class="text-4xl text-warning font-bold tracking-wider">It's me Forhad Uddin</h2>
                    <div className="flex items-center gap-1 md:gap-3">
                        <p className="text-[#f9cdc0] text-[20px] md:text-[31px] w-28 md:w-fit">I am a</p>
                        <span className="pt-4 md:pt-6">
                            <img
                                className="h-14"
                                src="https://readme-typing-svg.herokuapp.com?size=31&color=f9cdc0&lines=Frontend+Developer;Fullstack+Developer;MERN+Stack+Developer"
                                alt=""
                            />
                        </span>
                    </div>
                    <div>
                        <div className="connect flex gap-3">
                            <a href="https://github.com/forhad-eng" target="_blank" rel="noreferrer">
                                <img className="w-10" src={git} alt="" />
                            </a>
                            <a href="https://www.linkedin.com/in/itsforhad2" target="_blank" rel="noreferrer">
                                <img className="w-10" src={Linkedin} alt="" />
                            </a>
                            <a href="https://www.facebook.com/itsforhad2" target="_blank" rel="noreferrer">
                                <img className="w-10" src={fb} alt="" />
                            </a>
                        </div>
                    </div>
                    <div className="mt-4 flex gap-4">
                        <a href="#contact" class="btn btn-secondary">
                            Hire me
                        </a>

                        <a
                            href="https://drive.google.com/uc?id=1kESunrH2R8I-kXFsOGRow7zAVSA2gv6J&export=download"
                            class="btn btn-secondary"
                        >
                            Download cv
                        </a>
                    </div>
                </div>
                <img
                    data-aos="fade-left"
                    data-aos-duration="2000"
                    style={{ height: '350px' }}
                    src={developer}
                    alt="Forhad Uddin"
                />
            </div>
        </div>
    )
}

export default Hero
